module.exports = __webpack_public_path__ + "static/media/avatar12.a35ddfa3.png";